import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { fetchPointsHistoryReferral, useDispatch, useSelector } from "@jti/store";
import { Button, DEPRECATED_Typography as Typography } from "@jti/ui";
import trackCtaClick from "../../helpers/functions/trackCtaClick";
import { HistoryTable } from "../history-table/HistoryTable";
import styles from "./ReferralHistory.module.scss";
export const ReferralHistory = ({ pointsLabel, eventLabel, dateLabel, pointsUnit, title, rowsCount = 5, url, text, isInEditor, }) => {
    const dispatch = useDispatch();
    const { historyReferral } = useSelector((store) => store.loyaltyCore);
    const { isReferralOn } = useSelector((store) => store.loyaltyCore);
    const labels = { points: pointsLabel, event: eventLabel, date: dateLabel };
    useEffect(() => {
        dispatch(fetchPointsHistoryReferral(rowsCount));
    }, [dispatch, rowsCount]);
    const dispatchGTMEvent = () => {
        trackCtaClick(text, "ReferralHistoryCTA");
    };
    if ((historyReferral.total < 1 || !isReferralOn) && !isInEditor)
        return null;
    return (_jsxs("div", { className: styles.referralHistory, children: [_jsx("div", { className: styles.title, children: _jsx(Typography, { type: "small-title", color: "grey-3", children: title }) }), _jsx(HistoryTable, { rows: historyReferral.items, labels: labels, variant: "referral", pointsUnit: pointsUnit }), historyReferral.total > rowsCount && (_jsx("div", { className: styles.linkWrapper, children: _jsx(Button, { variant: "redirect", color: "secondary", size: "large", href: url, onClick: dispatchGTMEvent, children: text }) }))] }));
};
//# sourceMappingURL=ReferralHistory.js.map